module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/map-anno-hover-42.001c43576c31f09b.png"+" 42w",
        images: [{path: "https://static.sniffspot.com/packs/img/map-anno-hover-42.001c43576c31f09b.png",width: 42,height: 50}],
        src: "https://static.sniffspot.com/packs/img/map-anno-hover-42.001c43576c31f09b.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/map-anno-hover-42.001c43576c31f09b.png"},
        
        width: 42,
        height: 50
      }